import { IState } from '../../../store';
import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export const selectOffer = (state: IState): IOfferSchema => state.offerData.offer;
